import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import de from './de.json';

const STORAGE_KEY = 'etch.language';

// Detect saved language or browser default
function getInitialLanguage() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && ['en', 'de'].includes(saved)) return saved;
  } catch {}
  // Fall back to browser language, default to German
  const browserLang = navigator.language?.slice(0, 2);
  return browserLang === 'en' ? 'en' : 'de';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false // React already escapes
    }
  });

// Persist language changes
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {}
});

export default i18n;
